import { render, staticRenderFns } from "./DBQuery.vue?vue&type=template&id=b4d8f1e6&"
import script from "./DBQuery.vue?vue&type=script&lang=js&"
export * from "./DBQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports